import { createQueryKeys } from '../../factories';

const AI_SESSIONS_NAMESPACE = ['ai', 'sessions'];
const AI_PROMPTS_NAMESPACE = ['ai', 'prompts'];
const AI_EMBEDDED_NAMESPACE = ['ai', 'embedded_prompt'];
const BULK_GENERATE_AI_METADATA_NAMESPACE = [
	'bulk_generate_ai_metadata',
	'generate',
];

export const aiSessionsQueryKeyFactory = createQueryKeys(AI_SESSIONS_NAMESPACE);
export const aiPromptsQueryKeyFactory = createQueryKeys(AI_PROMPTS_NAMESPACE);
export const aiEmbeddedQueryKeyFactory = createQueryKeys(AI_EMBEDDED_NAMESPACE);
export const bulkGenerateAiMetadataQueryKeyFactory = createQueryKeys(
	BULK_GENERATE_AI_METADATA_NAMESPACE
);
